<template>
    <a class="btn btn-default header-list-space-button" @click="logSpaceListingClick">
        <p-icon-svg />
        <span>
            List your Space for free
        </span>
    </a>
</template>

<script>
    import PIconSvg from '!!babel-loader!vue-svg-loader!../../../../public/images/branding/p-icon.svg';
    import { logListASpaceClicked } from '../modules/mixpanel';

    export default {
        name: 'header-list-space-button',

        components: { PIconSvg },

        methods: {
            logSpaceListingClick() {
                logListASpaceClicked();
            },
        },
    };
</script>

<style lang="less" scoped>
    @import (reference) "~assets/less/variables";

    .header-list-space-button {
        display: flex;
        align-items: center;
        font-family: @font-family-base;
        font-weight: 700;
        font-size: 13px;
        padding: 6px 11px;

        &:hover {
            color: #ffffff;
            svg {
                /deep/ path {
                    fill: #ffffff;
                }
            }
        }
    }

    svg {
        margin-right: 6px;
        /deep/ path {
            transition: 0.15s;
        }
    }
</style>
